import { render, staticRenderFns } from "./salary_resign_3.vue?vue&type=template&id=ca29ef44&scoped=true"
import script from "./salary_resign_3.vue?vue&type=script&lang=ts"
export * from "./salary_resign_3.vue?vue&type=script&lang=ts"
import style0 from "./salary_resign_3.vue?vue&type=style&index=0&id=ca29ef44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca29ef44",
  null
  
)

export default component.exports